var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-md-12 slider m-b-5" },
    [
      _c(
        "transition-group",
        { staticClass: "list-unstyled", attrs: { name: "slide", tag: "ul" } },
        _vm._l(_vm.itemsDisplay, function (item) {
          return _c("li", { key: item.id }, [
            _c("div", {
              staticClass: "well well-shadow row",
              domProps: { innerHTML: _vm._s(item.content) },
            }),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }